(function () {
    'use strict';

    angular.module('app').controller('CorporateAccountsController', CorporateAccountsController);

    CorporateAccountsController.$inject = [
        '$rootScope',
        '$scope',
        '$routeParams',
        '$location',
        'BusinessService',
        'LANGS',
        'blockUI',
        'NotifyService',
        'GoodsService',
        'SettingsService',
        'EmbeddedService'
    ];

    function CorporateAccountsController(
        $rootScope,
        $scope,
        $routeParams,
        $location,
        BusinessService,
        LANGS,
        blockUI,
        NotifyService,
        GoodsService,
        SettingsService,
        EmbeddedService
    ) {

        $scope.model = {};
        $scope.data = {};

        // $scope.currencyList = {};
        $scope.getCurrenciesList = getCurrenciesList;
        $scope.multilang = MultilanguageHelper();

        // Declare depends functions
        $scope.isPageMode = isPageMode;

        var block_accounts_list = blockUI.instances.get('accounts_list');
        var block_account_edit = blockUI.instances.get('account_edit');

        $scope.platformSupportedLanguagesCodes = Object.keys(LANGS) || [];
        SettingsService.GetPlatformSupportedLanguages(function (success, response) {
            $scope.platformSupportedLanguagesCodes = response;
        });

        initController();

        // *********************************************************************************************
        //  MAIN PART
        // *********************************************************************************************

        /**
         * Page mode display different parts. Now 'show', 'create', 'edit'.
         * Use as <ANY ng-if="isPageMode('show')">
         */
        function isPageMode(mode) {
            return mode == $scope._pageMode;
        }

        /**
         * Check parameter 'mode' in route ../client-accounts/{mode}
         */
        function isRouteMode(mode) {
            return $routeParams && $routeParams.hasOwnProperty('mode') && $routeParams.mode === mode;
        }

        /**
         * Initialize page mode by url
         */
        function initPageMode() {
            $scope._pageMode = 'show';
            if (isRouteMode('edit')) {
                $scope._pageMode = ($routeParams.hasOwnProperty('account_id')) ? 'edit' : 'show';
            } else if (isRouteMode('create')) $scope._pageMode = 'create';
        }

        /**
         * Initialize controller
         */
        function initController() {
            $scope.multilang.initLangs(LANGS, $rootScope.LANG);

            initPageMode();

            switch ($scope._pageMode) {
                case 'create':
                    doCreate();
                    break;

                case 'show':
                    doShow();
                    break;

                case 'edit':
                    doEdit();
                    break;
            }
        }

        // *********************************************************************************************
        //  SHOW PART
        // *********************************************************************************************

        /**
         * Prepare data for display page in mode 'show'
         */
        function doShow() {
            function s() {
                if ($rootScope.ENV.business.tariff) {
                    if ($rootScope.ENV.business.tariff.special_accounts_processing) {
                        getSpecialAccounts();
                        $rootScope.TARIFF_LIMITATION.special_accounts_processing = false;
                    } else {
                        $rootScope.TARIFF_LIMITATION.special_accounts_processing = true;
                    }
                } else {
                    $timeout(s, 250);
                }
            }

            s();
        }

        function getSpecialAccounts() {
            block_accounts_list.start();
            BusinessService.SpecialAccountsParams({scope: 'corporate'}, function (success, data) {
                if (success) {
                    $scope.data.accountsList = $rootScope.ACCOUNTS;
                }
                block_accounts_list.stop();
            });
        }

        $scope.activeCorporateAccountsCount = function () {
            var active = 0;
            if ($scope.data.accountsList) {
                $scope.data.accountsList.forEach(function (item) {
                    if (item.active) active += 1;
                });
            }
            return active;
        };

        /**
         * Specified Account active state
         * @param news: News object
         */
        $scope.itemActive = function (account) {
            return account.active == 1;
        };

        /**
         * Click on 'Make news' button
         */
        $scope.onMakeAccountClick = function () {
            $location.path('/corporate-accounts/create');
        };

        /**
         * Account enable/disable click
         */
        $scope.onAccountToggleClick = function (account) {
            block_accounts_list.start();
            var post_data = {
                id: account.id,
                active: account.active == 1 ? 0 : 1
            };
            BusinessService.SpecialAccountEdit(account.id, post_data, function (success, data) {
                if (success) NotifyService.Success('', false);
                block_accounts_list.stop();
            });
        };

        // *********************************************************************************************
        //  CREATE & EDIT PART
        // *********************************************************************************************

        /**
         * Init Account string
         */
        function initLocaleStrings(account) {
            $scope.multilang.initStrings(account, ['public_title']);
        }

        /**
         * Make currency list for <select> element
         */
        function getCurrenciesList() {
            if (!$scope.data.currenciesList || $scope.data.currenciesList.length === 0)
                BusinessService.CurrencyList(null, function (success, response) {
                    if (success) {
                        $scope.data.currenciesList = response;

                        if ($scope.data.currenciesList.indexOf('EUR') == -1)
                            $scope.data.currenciesList.push('EUR');

                        if ($scope.data.currenciesList.indexOf('USD') == -1)
                            $scope.data.currenciesList.push('USD');
                    }
                });
        }

        function getGoods(callback) {
            $scope.model.goodsList = [];

            EmbeddedService.GetGoods({ service_type: 'all' }, function (success, data) {
                if (success) {
                    $scope.model.goodsList = angular.copy(data);
                }
                callback(success);
            });
        }

        /**
         * Prepare data for display page in mode 'create'
         */
        function doCreate() {
            getCurrenciesList();

            $scope.account = {
                corporate: 1,
                type: 'goods',
                credit_type: 'debit',
                unconfirmed_redeem_amount: 0,
                currency: $rootScope.ENV.business.currency
            };

            getGoods(function (success) {
            });

            initLocaleStrings($scope.account);
        }

        /**
         * Prepare data for display page in mode 'edit'
         */
        function doEdit() {
            block_account_edit.start();
            getCurrenciesList();

            function _makeDictTag(codesList) {
                var result = [];

                if (codesList) {
                    if ($scope.model.goodsList) {
                        codesList.forEach(function (code, index) {
                            var searchedItem = $scope.model.goodsList.find(function (item) {
                                if (item.code === code /*|| item.title === goodItem*/) {
                                    return true;
                                }
                            });
                            if (searchedItem) {
                                result.push({
                                    title: searchedItem.title,
                                    isTag: true,
                                    code: searchedItem.code
                                });
                            } else {
                                result.push({
                                    title: '',
                                    isTag: true,
                                    code: code
                                });
                            }
                            // $scope.model.goodsList.forEach(function (goodItem) {
                            //     if (code === goodItem.code) {
                            //         result.push(goodItem);
                            //     }
                            // });
                        });
                    } else {
                        result = codesList;
                    }
                }

                return result;
            }

            BusinessService.SpecialAccount($routeParams.account_id, function (success, data) {
                if (success) {
                    $scope.account = angular.copy(data);

                    $scope.model.goods_codes = _makeDictTag($scope.account.goods_items);
                    getGoods(function (success) {
                        if (success) {
                            $scope.model.goods_codes = _makeDictTag($scope.account.goods_items);
                        }
                    });

                    initLocaleStrings($scope.account);
                }
                block_account_edit.stop();
            });
        }

        /**
         * Cancel editing
         */
        $scope.onCancelEdit = function () {
            $location.path('/corporate-accounts');
        };

        /**
         * Add or update account
         * @param form
         * @param {boolean} isClose
         */
        $scope.onAccountSave = function (form, isClose) {
            console.info('FORM', form);

            function _makeTagArray(d) {
                var result = [];
                if (d)
                    d.forEach(function (item) {
                        result.push(item.code);
                    });
                return result;
            }

            $scope.account.goods_items = _makeTagArray($scope.model.goods_codes || form.goods.$modelValue) || null;

            var needGoods = ($scope.account.type == 'goods' && (!$scope.account.goods_items || $scope.account.goods_items.length == 0));
            var needCurrency = ($scope.account.type == 'money' && !$scope.account.currency);
            var needCreditLimit = ($scope.account.credit_type == 'credit' && !(parseInt($scope.account.credit_limit) > 0));

            console.info('ACCOUNT', $scope.account);
            console.info('needGoods', needGoods);

            function handleResult(success, response) {
                if (success) {
                    NotifyService.Success('', false);

                    if (!!isClose) {
                        $location.path('/corporate-accounts');
                    } else {
                        var _makeDictTag = function (codesList) {
                            var result = [];

                            if (codesList) {
                                if ($scope.model.goodsList) {
                                    codesList.forEach(function (code, index) {
                                        $scope.model.goodsList.forEach(function (goodItem) {
                                            if (code === goodItem.code) {
                                                result.push(goodItem);
                                            }
                                        });
                                    });
                                } else {
                                    result = codesList;
                                }
                            }
                            return result;
                        };
                        $scope.account = angular.copy(response);
                        $scope.model.goods_codes = _makeDictTag($scope.account.goods_items);
                    }

                }
            }

            if (form.title.$valid && form.public_title.$valid && !needGoods && !needCurrency) {
                var account = angular.copy($scope.account);

                // if(!!account.goods_items && typeof account.goods_item === null) {
                //     delete account.goods_item;
                // }

                if (account.goods_items) {
                    account.goods_items = account.goods_items.filter(function (value, index, self) {
                        return self.indexOf(value) === index;
                    });
                }

                if (!!account.id) {
                    BusinessService.SpecialAccountEdit(account.id, account, handleResult);
                } else {
                    BusinessService.SpecialAccountAdd(account, handleResult);
                }

            } else {
                if ($scope.account.type == 'goods') {
                    form.goods.$dirty = true;
                    form.goods.$invalid = needGoods;
                }
                if ($scope.account.type == 'money') {
                    form.currency.$dirty = true;
                    form.currency.$invalid = needCurrency;
                }

                if ($scope.account.credit_type == 'credit') {
                    form.credit_limit.$dirty = true;
                    form.credit_limit.$invalid = needCreditLimit;
                }

                form.public_title.$dirty = form.title.$dirty = true;
                console.info('FORM', form);
            }
        };

        /**
         * Event receive when change editing language
         */
        $scope.onChangeLanguage = function (new_lang) {
            $scope.multilang.selected(new_lang);
        };

        $scope.goodsTagHandler = function (code) {
            return {title: '', code: code};
        };

        $scope.pasteTagHandler = function (values) {
            var separators = [',', '\n'],
                separator,
                values_list;

            for (var i in separators)
                if (values && values.indexOf(separators[i]) > 0)
                    separator = separators[i];

            if (separator)
                values_list = values.replace(' ', '').split(separator);
            else
                values_list = values.split(' ');

            if (values_list && values_list.length > 0) {
                values_list = values_list.filter(function (elem, index, self) {
                    return index == self.indexOf(elem);
                });

                for (var i in values_list) {
                    if (!this.ngModel.$modelValue)
                        this.ngModel.$modelValue = [];
                    if (values_list[i]) {
                        this.ngModel.$modelValue.push({title: '', code: values_list[i]});
                    }
                }
            }
        };

        $scope.$watch('account.type', function (newValue, oldValue, scope) {
            if (newValue === 'money' && !$scope.account.currency)
                $scope.account.currency = $rootScope.ENV.business.currency;
        });
    }
})();
